import { render, staticRenderFns } from "./InformacoesSistemaDashboard.vue?vue&type=template&id=3aba6912&scoped=true"
import script from "./InformacoesSistemaDashboard.vue?vue&type=script&lang=js"
export * from "./InformacoesSistemaDashboard.vue?vue&type=script&lang=js"
import style0 from "./InformacoesSistemaDashboard.vue?vue&type=style&index=0&id=3aba6912&prod&lang=css"
import style1 from "./InformacoesSistemaDashboard.vue?vue&type=style&index=1&id=3aba6912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aba6912",
  null
  
)

export default component.exports